export default __webpack_public_path__ + "static/linear-mobile-f677e12750183564a73daa9235842c79.jpg";